import { useMemo } from 'react';
import useDeepCompare from './useDeepCompare.js';

function useMemoizedRender(deps) {
  return function (children) {
    return useMemo(function () {
      return children;
    }, useDeepCompare(deps));
  };
}

export default useMemoizedRender;
